import { Box, FormControl, FormHelperText, FormLabel } from "@mui/material";
import type { ReactNode } from "react";
import {
  chartOptionFieldControlBoxSx,
  chartOptionFieldLabelSx,
  chartOptionInputSx,
} from "../../lib/ui/formLayout";
import { useAppCustomStyles } from "../../assets/theme/custom/hooks";

type Props = {
  label: string;
  helperText?: string;
  disabled?: boolean;
  /** Use for switches; text/select fields fill the control row. */
  centerControl?: boolean;
  children: ReactNode;
};

/** Shared label + control height shell for chart option panels. */
export default function ChartOptionFieldShell({
  label,
  helperText,
  disabled,
  centerControl = false,
  children,
}: Props) {
  const custom = useAppCustomStyles();
  const styles = custom.components.chartOptionPanels;

  return (
    <FormControl
      fullWidth
      margin="dense"
      size="small"
      disabled={disabled}
      sx={styles.fieldShellFormControl}
    >
      <FormLabel sx={chartOptionFieldLabelSx}>{label}</FormLabel>
      <Box sx={styles.fieldShellControlBox(centerControl)}>
        {children}
      </Box>
      {helperText ? (
        <FormHelperText sx={styles.helperText}>{helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
}
